import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {MaterialCostSearchFilterData} from "../types/MaterialCostSearchFilterData";

export const useGetMaterialCostFilterData = () => {
	const { data, isLoading } = useQuery({
		queryKey: ['material-cost-filters'],
		queryFn: async () => await apiClient.get('material-cost/filter-data') as MaterialCostSearchFilterData
	});

	return {
		data,
		isLoading
	};
};
